import { Tokens } from "./auth.types";

export const AUTH_KEYS = {
  GET_ME: (tokens: Tokens | null) => ["me", tokens],
  LOGIN: ["login"],
  LOGOUT: ["logout"],
};
